module.exports = __webpack_public_path__ + "static/media/tra_par.7658ba88.png";